import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles';
import { styledBy } from '../../models/AlmeIvaTypeMapping';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ breakpoints, palette, shadows, spacing }: Theme) {
    const mainShadow = shadows[5];
    const backgroundColor = palette.background.default;
    const gutterPx = spacing(2);
    const dividerColor = palette.divider;
    const dividerBorder = `1px solid ${dividerColor}`;
    const maxHeight = 650;
    const width = 450;
    return createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor,
            border: dividerBorder,
            boxShadow: mainShadow,
        },
        rootIvaType: {
            [breakpoints.down('sm')]: {
                width: styledBy('ivaType', {
                    embedded: '100%',
                    popup: '100%',
                    inline: '100%',
                }),
                height: styledBy('ivaType', {
                    embedded: `100%`,
                    popup: '100%',
                    inline: '100%',
                }),
                bottom: styledBy('ivaType', {
                    embedded: `0`,
                    popup: 'auto',
                    inline: 'auto',
                }),
                right: styledBy('ivaType', {
                    embedded: `0`,
                    popup: 'auto',
                    inline: 'auto',
                }),
            },
            [breakpoints.up(768)]: {
                width: styledBy('ivaType', {
                    embedded: `${width}px`,
                    popup: '100%',
                    inline: '100%',
                }),
                height: styledBy('ivaType', {
                    embedded: `calc(100% - ${gutterPx * 2}px)`,
                    popup: '100%',
                    inline: '100%',
                }),
                maxHeight: styledBy('ivaType', {
                    embedded: `${maxHeight}px`,
                    popup: 'none',
                    inline: 'none',
                }),
                bottom: styledBy('ivaType', {
                    embedded: `${gutterPx}px`,
                    popup: 'auto',
                    inline: 'auto',
                }),
                right: styledBy('ivaType', {
                    embedded: `${gutterPx}px`,
                    popup: 'auto',
                    inline: 'auto',
                }),
            },
            margin: styledBy('ivaType', {
                embedded: 0,
                popup: 'auto auto',
                inline: 'auto auto',
            }),
            position: styledBy('ivaType', {
                embedded: 'fixed',
                popup: 'static',
                inline: 'static',
            }) as unknown as 'static' | 'fixed',
        },
        rootPulse: {
            boxShadow: `0 0 0 ${fade(palette.primary.main, .75)}`,
            animation: `$pulse 2s infinite`,
            '&:hover': {
                animation: 'none',
            },
        },
        '@keyframes pulse': {
            '0%': {
                boxShadow: `0 0 0 0 ${fade(palette.primary.main, .75)}`,
            },
            '70%': {
                boxShadow: `0 0 0 10px ${fade(palette.primary.main, 0)}`,
            },
            '100%': {
                boxShadow: `0 0 0 0 ${fade(palette.primary.main, 0)}`,
            },
        },
    });
}
